import React from "react";
import { Container, Logo } from "./Styled";
import VerbitLogoSS from "./Assets/Verbit_Logo_SS.svg";
import VerbitLogo from "./Assets/Verbit_Logo.svg";

interface HeaderProps {
  template_name: string | null;
}
const Header: React.FC<HeaderProps> = ({ template_name }: HeaderProps) => {
  return (
      <Container>
        {template_name && template_name === 'ss' ? <Logo src={VerbitLogoSS} alt="" /> : <Logo src={VerbitLogo} alt="" />}
      </Container>
  );
};

export default Header;
